import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MemberDashboard from './pages/member-dashboard/MemberDashboard';
import PointAdjustmentsPage from './pages/point-adjustments/PointAdjustmentsPage';
import EarnPointsPage from './pages/earn-points/EarnPointsPage';
import CommentsPage from './pages/comments/CommentsPage';
import WelcomePage from './pages/welcome/WelcomePage';
import AuthProvider from './auth/AuthProvider';
import ProtectedApp from './auth/ProtectedApp';
import config from './config';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AuthProvider>
    <ProtectedApp>
      <BrowserRouter basename={config.routerBasename}>
        <Routes>
          <Route path="/logincallback" element={<WelcomePage />} />
          <Route path="/" element={<WelcomePage />} />
          <Route path="/member-dashboard" element={<MemberDashboard />} />
          <Route path="/point-adjustments" element={<PointAdjustmentsPage />} />
          <Route path="/earn-points" element={<EarnPointsPage />} />
          <Route path="/comments" element={<CommentsPage />} />
        </Routes>
      </BrowserRouter>
    </ProtectedApp>
  </AuthProvider>
);
